// The steps a project still needs before its agents get documents, email and
// Slack on their own. Each jumps to its section of the Settings tab below.
import { setupSectionId, type SetupStep } from "../state/useProjectSetupSteps";
import styles from "./ProjectSetupBanner.module.css";

export const ProjectSetupBanner = ({ steps }: { steps: SetupStep[] }) => {
  const left = steps.filter((s) => s.state === "incomplete");
  if (left.length === 0) return null;
  return (
    <div className={styles.banner} role="status">
      <div className={styles.head}>
        Finish setting up this project: {left.length} step{left.length === 1 ? "" : "s"}{" "}
        left
      </div>
      <ul className={styles.steps}>
        {left.map((s) => (
          <li key={s.id}>
            <button
              type="button"
              className={styles.step}
              onClick={() =>
                document
                  .getElementById(setupSectionId(s.id))
                  ?.scrollIntoView({ behavior: "smooth", block: "start" })
              }
            >
              {s.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
